import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { zipSync } from 'fflate';

import { fetchUrls, saveAsFile } from 'utils/download';

export const download = createAsyncThunk(
  'certificate/download',
  async ({ urls, schema, zipFileName }, { rejectWithValue }) => {
    try {
      const { results, errors } = await fetchUrls(urls);
      if (results.length) {
        const files = {};

        results.forEach(({ url, data }) => {
          if (schema === 'certificates') {
            const urlSplit = url.split('/Certificates/');
            const folderName = urlSplit[0]
              .split('/Games/')
              .pop()
              .replace(/\+/g, ' ');
            const folderPath = `${folderName}/${urlSplit[1]}`;
            files[folderPath] = data;
          } else {
            const filePath = url.split('/').pop();
            files[filePath] = data;
          }
        });

        const zipFile = new Blob([zipSync(files)], { type: 'application/zip' });
        saveAsFile(zipFile, `${zipFileName}.zip`);
      }
      if (errors.length) {
        return rejectWithValue(errors);
      }
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const initialState = {
  loading: false,
  error: null,
};

export const certificateSlice = createSlice({
  name: 'certificate',
  initialState,
  extraReducers: (builder) => {
    const { pending, fulfilled, rejected } = download;
    builder
      .addCase(pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(rejected, (state, action) => {
        state.loading = false;
        let errorText = action.payload;
        if (Array.isArray(action.payload)) {
          errorText = '<b>Error fetch urls:</b><br/>';
          action.payload.map(({ url }) => (errorText += url + '<br/>'));
        }
        state.error = errorText;
      });
  },
});

export const certificateSelector = {
  getLoading: (state) => state.certificate.loading,
  getError: (state) => state.certificate.error,
};

export default certificateSlice.reducer;
